/* eslint-disable */
import { Row, Col, Form, Tab, Tabs, Button, Container } from "react-bootstrap";
import { useState, useRef, useEffect } from "react";
import { FaHistory } from "react-icons/fa";
import { FormatComms } from "../ProblemForm/FormatComms";
import ModernViewer from "../Notes/ModernViewer";
import VersionHistory from "../VersionHistory/VersionHistory";
// Generated by GitHub Copilot
import { ConfigurationAPI } from "../../connections/Configuration";
// Generated by GitHub Copilot
import WorkflowHistoryViewer from "./WorkflowHistoryViewer";
import PagerDutyActivity from "../Modern/IncidentDetails/PagerDutyActivity";
// Generated by GitHub Copilot
import InterestedPartiesViewer from "./InterestedPartiesViewer";
// Generated by GitHub Copilot
import ImpactReportsViewer from "./ImpactReportsViewer";
import ViewerItem from "./ViewerItem";
import { hasEditorAccess } from "../../utils/privilegeHelpers";
import {
  hasIncidentLinkageContext,
  resolveIncidentDisplayWithPlaceholder,
} from "../../utils/incidentLinkage";

function TabbedViewer(props) {
  const outage = props.outage;
  const slackURL = props.slackURL;
  const problem = props.problem;
  const user = props.user;
  // Generated by GitHub Copilot - Trigger for refreshing impact list
  const impactRefreshTrigger = props.impactRefreshTrigger;

  const awsCase = outage && outage.awscase ? outage.awscase : "";

  // Generated by GitHub Copilot
  // State for feature toggle
  const [showRevisions, setShowRevisions] = useState(false);

  // Generated by GitHub Copilot
  // Fetch config and set showRevisions on mount
  useEffect(() => {
    ConfigurationAPI.get().then((config) => {
      if (config && Array.isArray(config.featureToggles)) {
        const toggle = config.featureToggles.find(
          (t) => t.name === "showRevisionsToTheWorld",
        );
        setShowRevisions(!!(toggle && toggle.enabled));
      }
    });
  }, []);

  // Generated by GitHub Copilot
  // State for managing version count and refresh
  const [versionCount, setVersionCount] = useState(0);
  const versionHistoryRef = useRef();

  // Generated by GitHub Copilot
  // Handle tab selection to refresh revisions when tab is entered
  const handleTabSelect = (key) => {
    if (
      key === "revisions" &&
      versionHistoryRef.current &&
      versionHistoryRef.current.refreshVersions
    ) {
      versionHistoryRef.current.refreshVersions();
    }
  };

  // Generated by GitHub Copilot
  // Handle version count changes
  const handleVersionCountChange = (count) => {
    setVersionCount(count);
  };

  return (
    <Tabs
      defaultActiveKey={"overview"}
      className="mb-3"
      onSelect={handleTabSelect}
    >
      {/* react-bootstrap's Tab doesn't forward data-testid to the rendered
          nav link — title text is wrapped in a span carrying it instead
          (click bubbles to the parent tab; accessible name is unaffected). */}
      <Tab
        eventKey="overview"
        title={
          <span data-testid="view-tab-overview">Incident Overview</span>
        }
      >
        <ViewerItem
          title="Incident Status"
          id="status"
          value={outage && outage.status ? outage.status : ""}
        />
        {hasEditorAccess(user) &&
          problem &&
          (hasIncidentLinkageContext(
            problem.incidentNumber,
            problem.number,
          ) ||
            awsCase) && (
            <ViewerItem
              title="Incident Number"
              id="incidentNumber"
              value={resolveIncidentDisplayWithPlaceholder(
                problem.incidentNumber,
                problem.number,
                !!awsCase,
              )}
            />
          )}
        {hasEditorAccess(user) && problem && awsCase && (
          <ViewerItem
            title="AWS Case #"
            id="awscase"
            value={awsCase}
          />
        )}
        <ViewerItem
          id="nextUpdate"
          title="Next Update"
          value={outage ? outage.nextUpdate : ""}
        />
        <ViewerItem
          title="Current Status"
          id="currentStatus"
          value={
            outage && outage.currentStatus ? outage.currentStatus : "Loading..."
          }
        />

        <ViewerItem
          title="Incident Commander"
          id="incidentCommander"
          value={
            outage && outage.incidentCommander ? outage.incidentCommander : ""
          }
        />
        <ViewerItem
          title="Incident Manager"
          id="incidentManager"
          value={outage && outage.mim ? outage.mim : ""}
        />
        <ViewerItem
          title="Business Liaison"
          id="businessLiaison"
          value={outage.businessLiaison ? outage.businessLiaison : ""}
        />

        {/* Generated by GitHub Copilot */}
        {outage &&
          outage.interestedParties &&
          outage.interestedParties.length > 0 && (
            <Row>
              <Col>
                <Form.Label>Interested Parties</Form.Label>
                <InterestedPartiesViewer
                  interestedParties={outage.interestedParties}
                />
              </Col>
            </Row>
          )}
      </Tab>
      <Tab
        eventKey="impact"
        title={
          <span data-testid="view-tab-impact">Client-Business Impact</span>
        }
      >
        <ViewerItem
          title="Client Impact"
          id="clientImpact"
          value={outage && outage.impact ? outage.impact : ""}
        />
        <ViewerItem
          title="Workaround"
          value={outage && outage.workaround ? outage.workaround : ""}
        />
        <ViewerItem
          title="Affected Users"
          value={outage && outage.affectedUsers ? outage.affectedUsers : ""}
        />

        <ViewerItem
          title="Message for External Clients"
          value={
            outage && outage.messageForClients ? outage.messageForClients : ""
          }
        />
        <ViewerItem
          title="Number of Contacts"
          value={
            outage && outage.numberOfContacts ? outage.numberOfContacts : ""
          }
        />
        <ViewerItem
          title="Impact Begin"
          id="impactStart"
          value={outage && outage.incidentStart ? outage.incidentStart : ""}
        />
        <ViewerItem
          title="Impact End"
          id="impactEnd"
          value={outage && outage.incidentEnd ? outage.incidentEnd : ""}
        />
        <ViewerItem
          title="SalesForce Case #"
          value={outage && outage.salesForceCase ? outage.salesForceCase : ""}
        />

        {/* Generated by GitHub Copilot */}
        {/* Display impact reports when impact reporting is enabled */}
        {problem && problem.number && !problem.temporary && (
          <Row className="mt-3">
            <Col>
              <Form.Label>Impact Reports</Form.Label>
              <Row>
                <Col className="priorityDescription">
                  My Reports are highlighted in blue and listed first
                </Col>
              </Row>
              <ImpactReportsViewer
                problemNumber={problem.number}
                user={user}
                refreshTrigger={impactRefreshTrigger}
              />
            </Col>
          </Row>
        )}
      </Tab>
      <Tab
        eventKey="technical"
        title={
          <span data-testid="view-tab-technical">Technical Impact</span>
        }
      >
        <ViewerItem
          title="Technical Status"
          value={outage && outage.technicalStatus ? outage.technicalStatus : ""}
        />
        <ViewerItem
          title="Perceived Cause"
          value={outage && outage.perceivedCause ? outage.perceivedCause : ""}
        />
        <ViewerItem
          title="Current Approach"
          value={outage && outage.currentApproach ? outage.currentApproach : ""}
        />
        <ViewerItem
          title="Vendor Ticket"
          value={outage && outage.vendorTicket ? outage.vendorTicket : ""}
        />
        <ViewerItem
          title="AWS Account"
          value={outage && outage.awsAccount ? outage.awsAccount : ""}
        />
        <ViewerItem
          title="Time Detected"
          id="timeDetected"
          value={outage && outage.timeDetected ? outage.timeDetected : ""}
        />
        <ViewerItem
          title="Command Center Notified"
          id="EOCNotified"
          value={outage && outage.eocNotified ? outage.eocNotified : ""}
        />
        <ViewerItem
          title="Technical Time of Resolution"
          value={
            outage && outage.techTimeResolved ? outage.techTimeResolved : ""
          }
        />

        <ViewerItem
          title="Slack Channel"
          id="slackChannel"
          value={
            outage && outage.slackChannel ? (
              <a target="blank" href={slackURL}>
                {outage.slackChannel}
              </a>
            ) : (
              ""
            )
          }
        />

        {outage && outage.pagerDutyID ? (
          <Col xs={12} md={4} lg={3} xl={3}>
            <Row>
              <Col>
                {outage && outage.pagerDutyID ? (
                  <a
                    href={
                      "https://coxauto.pagerduty.com/incidents/" +
                      outage.pagerDutyID +
                      "/timeline"
                    }
                    target="_blank"
                  >
                    <Button variant="success">View PagerDuty Timeline</Button>
                  </a>
                ) : (
                  "None"
                )}
              </Col>
            </Row>
          </Col>
        ) : (
          <></>
        )}

        {/* Generated by GitHub Copilot */}
        {outage &&
          outage.workflow_invocations &&
          outage.workflow_invocations.length > 0 && (
            <Row>
              <Col>
                <Form.Label>PD Workflow History</Form.Label>
                <WorkflowHistoryViewer
                  workflowHistory={outage.workflow_invocations}
                />
              </Col>
            </Row>
          )}

        {problem && problem.number && outage && outage.number && (
          <Row>
            <Col>
              <PagerDutyActivity
                problemID={problem.number}
                outageID={outage.number}
                isActive={!(outage && outage.status && String(outage.status).toLowerCase() === "resolve")}
              />
            </Col>
          </Row>
        )}

      </Tab>
      <Tab
        eventKey="communications"
        title={
          <span data-testid="view-tab-communications">Communications</span>
        }
      >
        {problem && <FormatComms communications={problem.communications} />}
      </Tab>
      <Tab
        eventKey="timeline"
        title={
          <span data-testid="view-tab-timeline">Preliminary Timeline</span>
        }
      >
        <Row>
          <Col>
            <Form.Label>Timeline</Form.Label>
            {/* Generated by GitHub Copilot */}
            {/* Display timeline entries from outage notes (important, public notes are timeline entries) */}
            {outage.notes ? (
              <>
                <Row>
                  <Col>
                    <Form.Label>Notes</Form.Label>
                    <ModernViewer
                      showEyeballs={false}
                      showPIRs={true}
                      notes={outage.notes}
                      controls={false}
                    />
                  </Col>
                </Row>
              </>
            ) : (
              <></>
            )}
          </Col>
        </Row>
      </Tab>

      {/* Generated by GitHub Copilot */}
      {/* Revisions tab with version history */}
      {/* Generated by GitHub Copilot: Only show revisions tab if feature toggle is enabled */}
      {showRevisions && (
        <Tab
          eventKey="revisions"
          title={<span data-testid="view-tab-revisions">{`Revisions ${versionCount > 0 ? `(${versionCount})` : ""}`}</span>}
        >
          <Container>
            <Row>
              <Col xs={12}>
                <h5>
                  <FaHistory className="me-2" />
                  Document Version History ({versionCount} versions)
                </h5>
                {problem && problem.number && (
                  <VersionHistory
                    ref={versionHistoryRef}
                    problemId={problem.number}
                    onVersionCountChange={handleVersionCountChange}
                  />
                )}
              </Col>
            </Row>
          </Container>
        </Tab>
      )}
    </Tabs>
  );
}

export default TabbedViewer;
